import React from "react";
import CreateReportComponent from "../components/CreateReportComponent";
import CreateReportComponentNew from "../components/CreateReportComponentNew";

const CreateReport = () => {
  return (
    <div>
      {/* <CreateReportComponent /> */}
      <CreateReportComponentNew />
    </div>
  );
};

export default CreateReport;
